"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSvgIcon;
var _createSvg = _interopRequireWildcard(require("./createSvg"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function createSvgIcon(/** The type of inline SVG element to use */
inlineSvg, /** The name of the SVG element. */
name, /** The size of the SVG element. */
size, /** The file name of the SVG element. Needed to create an SVG path if the icon has variations. */
fileName) {
  const fullIconName = fileName || `${name}${size}`;
  const path = `${_createSvg.externalBasePath}/Icons/${name}/${size}/${fullIconName}.svg#root`;
  const sizeMap = {
    SM: 16,
    MD: 24,
    LG: 32
  };
  const dimension = sizeMap[size];
  return (0, _createSvg.default)({
    inlineSvg,
    width: dimension,
    height: dimension,
    name,
    path
  });
}